module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-services container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.services) ? _c('div', {
    staticClass: "column content is-hidden-tablet",
    staticStyle: {
      "margin-top": "0",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.services.image ? _vm.services.image.path : ''
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.services) ? _c('div', {
    staticClass: "column content content-main is-right",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.services.title) + "\n        ")]), _vm._v(" "), (_vm.services.content) ? _c('markdown', {
    attrs: {
      "source": _vm.services.content
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.services && _vm.note) ? _c('div', {
    staticClass: "column content",
    staticStyle: {
      "margin-top": "0",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive is-hidden-mobile",
    attrs: {
      "src": _vm.services.image ? _vm.services.image.path : ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box color-gray-lighter-bg"
  }, [(_vm.note.content) ? _c('markdown', {
    attrs: {
      "source": _vm.note.content
    }
  }) : _vm._e()], 1)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49f9de88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Services.vue
// module id = 974
// module chunks = 1